import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import VideoCard from "@/components/feature/VideoCard";
import { categories, getCategoryBySlug, getVideosByCategory } from "@/mocks/videos";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || "dianshiju");

  useEffect(() => {
    if (slug) {
      setActiveCategory(slug);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [slug]);

  const category = getCategoryBySlug(activeCategory);
  const categoryVideos = getVideosByCategory(activeCategory);

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: `${category?.name || ""} - 神马视频`,
    description: category?.description || "",
    url: `https://www.shenmavideo.com/category/${activeCategory}`,
    isPartOf: {
      "@type": "WebSite",
      name: "神马视频",
      url: "https://www.shenmavideo.com",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <Breadcrumb
            items={[
              { label: "首页", href: "/" },
              { label: category?.name || "分类" },
            ]}
          />

          <section className="w-full px-4 md:px-6 py-6 md:py-10">
            <div className="max-w-7xl mx-auto">
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
                {category?.name}
              </h1>
              <p className="mt-2 text-sm text-foreground-500">
                {category?.description}
              </p>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 pb-4">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-2 overflow-x-auto pb-2 flex-wrap">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                      activeCategory === cat.slug
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-100 text-foreground-600 hover:bg-background-200"
                    }`}
                  >
                    <i className={`${cat.icon} mr-1.5`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-6 md:py-10">
            <div className="max-w-7xl mx-auto">
              {categoryVideos.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                  {categoryVideos.map((video) => (
                    <VideoCard
                      key={video.id}
                      slug={video.slug}
                      title={video.title}
                      categoryName={video.categoryName}
                      description={video.description}
                      coverImage={video.coverImage}
                      rating={video.rating}
                      views={video.views}
                      updateStatus={video.updateStatus}
                      episodeCount={video.episodeCount}
                    />
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                    <i className="ri-inbox-line text-2xl"></i>
                  </div>
                  <p className="mt-4 text-foreground-500">该分类暂无内容</p>
                </div>
              )}
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}